import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {VacantBedComponent} from './vacant-bed.component';
import {routing} from './vacent-bed.routing';
import {SharedTranslationModule} from '../../../../shared/change-language/shared-translation.module';
import {TrnBedStatusService} from '../../../../configuration/trn-bed-status/trn-bed-status.service';

@NgModule({
  imports: [
    CommonModule,
    routing,
    SharedTranslationModule
  ],
  declarations: [VacantBedComponent],
  providers: [TrnBedStatusService]
})
export class VacantBedModule {
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/ipd/bed-management/under-maintenance/vacant-bed/vacant-bed.module.ts